import * as SwitchPrimitives from '@radix-ui/react-switch';
import * as React from 'react';

import { cn } from '@heidi/utils';

import { switchVariants, thumbVariants } from './switch.styles';
import type { SwitchProps } from './switch.types';

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  SwitchProps
>(
  (
    {
      className,
      size,
      onCheckedChange,
      onPointerEnter,
      onPointerLeave,
      disabled,
      ...props
    },
    ref
  ) => {
    const [hoverActive, setHoverActive] = React.useState(false);

    return (
      <SwitchPrimitives.Root
        className={cn(switchVariants({ size, className }))}
        disabled={disabled}
        {...props}
        ref={ref}
        data-hover-active={hoverActive || undefined}
        onPointerEnter={(e) => {
          if (!disabled && e.pointerType !== 'touch') setHoverActive(true);
          onPointerEnter?.(e);
        }}
        onPointerLeave={(e) => {
          setHoverActive(false);
          onPointerLeave?.(e);
        }}
        onCheckedChange={(checked) => {
          setHoverActive(false);
          onCheckedChange?.(checked);
        }}
      >
        {/* Thumb masked via clip-path inset; animating clip-path+transform keeps hover on compositor. */}
        <SwitchPrimitives.Thumb
          className={cn(
            'pointer-events-none block rounded-full bg-background-switch-thumb ring-0 transition-[transform,clip-path] duration-200 ease-out will-change-[transform,clip-path] group-disabled:opacity-70 data-[state=unchecked]:translate-x-0 motion-reduce:transition-none',
            thumbVariants(size)
          )}
        />
      </SwitchPrimitives.Root>
    );
  }
);
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
